import { render, staticRenderFns } from "./CaseModules.vue?vue&type=template&id=e664088a&"
import script from "./CaseModules.vue?vue&type=script&lang=js&"
export * from "./CaseModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports